export default "__VITE_ASSET__DRg6$k7g__"